import React from 'react';
import { View, StyleSheet } from 'react-native';
import { COLORS } from '../constants';
import { DefinitionsList } from '../components'

export default function DefinitionsScreen() {
  return (

    <View style={styles.container}>
        <DefinitionsList/>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
      flex: 1,
      backgroundColor: COLORS.background,
  },
  tbl: {
      color: COLORS.primary,
  },
  bg: {
    width: '100%',
    height: '100%'
  },
});